// extracted by mini-css-extract-plugin
export default {"iframe":"YoutubeVideo_iframe__fKuMy","carouselNext":"YoutubeVideo_carouselNext__qMC7g","carouselPrev":"YoutubeVideo_carouselPrev__2+L90"};